import React from 'react';
import { FAIcon } from '../../fa-icon/component.js';
var LegacyDismissAction = function LegacyDismissAction(props) {
  var dismissable = props.dismissable,
    onDismiss = props.onDismiss;
  if (!dismissable || typeof onDismiss !== 'function') return null;

  // As it is imeplemented, FAICon does not accept icon props.
  // TODO Remove this ts-ignore after FAIcon has been properly refactored
  // @ts-ignore
  return /*#__PURE__*/React.createElement(FAIcon, {
    icon: "xmark",
    additionalClasses: "card-dismiss",
    onClick: onDismiss
  });
};
LegacyDismissAction.displayName = "LegacyDismissAction";
LegacyDismissAction.displayName = 'LegacyDismissAction';
export { LegacyDismissAction };